exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-b50ef614] {\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 3.125rem;\n  margin-left: 0.5rem;\n}\n.app-breadcrumb.el-breadcrumb .redirect[data-v-b50ef614] {\n  color: #ffffff;\n  font-weight: bold;\n}\n.app-breadcrumb.el-breadcrumb .redirect[data-v-b50ef614]:hover {\n  color: #304156;\n}\n.app-breadcrumb.el-breadcrumb .el-breadcrumb__separator[data-v-b50ef614] {\n  color: #d4d4d4;\n}\n.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614] {\n  color: #d4d4d4;\n  cursor: text;\n}", ""]);

// exports
